import { makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { Image } from 'expo-image'
import React from 'react'
import { FlatList, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { PressableOpacity } from 'shared/components/pressable_opacity'
import { Tool } from 'tools/types'

interface Props {
  tools: Tool[] | undefined
  onPressTool: (tool: Tool) => void
  hasTextOnlyUsers: boolean
}

export default function ToolsView({
  tools,
  onPressTool,
  hasTextOnlyUsers,
}: Props) {
  const styles = useStyles()
  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.container}>
      <FlatList
        data={tools}
        contentContainerStyle={styles.listContainer}
        keyExtractor={item => String(item.id)}
        renderItem={({ item }) =>
          item.name === 'text_only_download_crew' &&
          !hasTextOnlyUsers ? null : (
            <PressableOpacity key={item.id} onPress={() => onPressTool(item)}>
              <View style={styles.containerInside}>
                <Image
                  style={styles.toolImage}
                  source={{ uri: item.iconUrl }}
                />
                <Text style={styles.toolTitle}>{item.title}</Text>
              </View>
            </PressableOpacity>
          )
        }
        ListEmptyComponent={EmptyListComponent}
      />
    </SafeAreaView>
  )
}

function EmptyListComponent() {
  const styles = useStyles()
  return (
    <View style={styles.emptyListContainer}>
      <Text>{t('noToolsAvailable')}</Text>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
  },
  listContainer: {
    flexGrow: 1,
    padding: 10,
    paddingBottom: 50,
  },
  containerInside: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: theme.colors?.grey6,
    padding: 15,
    marginBottom: 10,
  },
  toolImage: {
    width: 24,
    height: 24,
  },
  toolTitle: {
    fontSize: 15,
    paddingLeft: 10,
    color: theme.colors?.black,
  },
  emptyListContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
}))
